module.exports = __webpack_public_path__ + "media/images/oculos_mergulho-043a5d74528b4db1fba31fcf9b6b61ad.png";